// @flow

import styled from "styled-components";
import { fontCondensed } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

export const AddFundsWrapper = styled.div`
  a {
    height: 28px;
  }
`;

export const Container = styled.div`
  height: 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const ColumnCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
`;

export const Label = styled.span`
  font-family: ${fontCondensed};
  text-transform: uppercase;
  color: ${buildColor("white")};
  text-align: right;
  font-size: 12px;
  white-space: nowrap;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 1px;
`;

export const IconContainer = styled.div`
  width: 28px;
  height: 28px;
  background-color: ${buildColor("green")};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`;
